/* Deferred analytics — loaded from layout/theme.liquid */
(function () {
  function boot() {
    window.TriplePixelData = {
      TripleName: 'volitiondev.myshopify.com',
      ver: '2.11',
      plat: 'SHOPIFY',
      isHeadless: false
    };
    (function (W, H, A, L, E, _, B, N) {
      function O(U, T, P, req, R) {
        void 0 === R && (R = false);
        req = new XMLHttpRequest();
        if (P) {
          req.open('POST', U, true);
          req.setRequestHeader('Content-Type', 'application/json');
        } else {
          req.open('GET', U, true);
        }
        req.send(JSON.stringify(P || {}));
        req.onreadystatechange = function () {
          if (4 === req.readyState && 200 === req.status) {
            R = req.responseText;
            if (U.indexOf('.txt') !== -1) {
              // eslint-disable-next-line no-eval
              eval(R);
            } else if (!P) {
              N[B] = R;
            }
          } else if ((req.status > 299 || req.status < 200) && T && !R) {
            O(U, T - 1, P);
          }
        };
      }
      N = window;
      if (!N[H + 'sn']) {
        N[H + 'sn'] = 1;
        L = function () {
          return Date.now().toString(36) + '_' + Math.random().toString(36);
        };
        try {
          A.setItem(H, 1 + (0 | A.getItem(H) || 0));
          E = JSON.parse(A.getItem(H + 'U') || '[]');
          E.push({
            u: location.href,
            r: document.referrer,
            t: Date.now(),
            id: L()
          });
          A.setItem(H + 'U', JSON.stringify(E));
        } catch (err) {}
        if (!A.getItem('"!nC`')) {
          _ = A;
          A = N;
          if (!A[H]) {
            E = A[H] = function (t, e, a) {
              if (a === undefined) a = [];
              if (t == 'State') return E.s;
              W = L();
              (E._q = E._q || []).push([W, t, e].concat(a));
              return W;
            };
            E.s = 'Installed';
            E._q = [];
            E.ch = W;
            B = 'configSecurityConfModel';
            N[B] = 1;
            O('https://conf.config-security.com/model', 5);
            var i = L();
            var m = A[atob('c2NyZWVu')];
            _.setItem('di_pmt_wt', i);
            var p = {
              id: i,
              action: 'profile',
              avatar: _.getItem('auth-security_rand_salt_'),
              time: m[atob('d2lkdGg=')] + ':' + m[atob('aGVpZ2h0')],
              host: A.TriplePixelData.TripleName,
              plat: A.TriplePixelData.plat,
              url: window.location.href,
              ref: document.referrer,
              ver: A.TriplePixelData.ver
            };
            O('https://api.config-security.com/event', 5, p);
            O('https://whale.camera/live/dot.txt', 5);
          }
        }
      }
    })('', 'TriplePixel', localStorage);

    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', 'kh59fb0sfy');

    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', 'p13ox1jn9l');
  }

  if (document.readyState === 'complete') {
    boot();
  } else {
    window.addEventListener('load', boot);
  }
})();
